import React, { Component } from 'react';
import { connect } from 'react-redux';
import { ImagesActions } from '../../../actions';
import {Submit} from '../../Form';

class TrashLayer extends Component {
    sendToTrash() {
        const {eventID, imageID, dispatch, onClose} = this.props;

        dispatch(ImagesActions.updateImage(eventID, imageID, {copies: 0}));   
        onClose();     
    }

    deletePermanently() {
        const {eventID, imageID, dispatch, copies, cache} = this.props;

        if(copies !== 0) return;
        dispatch(ImagesActions.deleteImage(eventID, imageID));
        if(cache) cache.deleteImage(imageID).then().catch();
    }

    render() {
        const {copies, onClose, images, imageID} = this.props;

        return (
            <div id="goToTrash" className="imgLayer">
                <div className="title">
                    {copies > 0 ? 'לזרוק לפח?' : 'למחוק לצמיתות?'}
                </div>
                <div className="action">
                    <Submit 
                        className="buttons"
                        onClick={copies > 0 ? this.sendToTrash.bind(this) : this.deletePermanently.bind(this)}
                        process={images.deleteImageProcessList && images.deleteImageProcessList[imageID]}
                        text="כן"
                    />
                    &nbsp;&nbsp;
                    <div className="buttons" onClick={onClose}>
                        לא
                    </div>
                </div>
            </div>
        )
    }
}

const mapStateToProps = (state) => {
    return {
        images: state.imagesReducer
    }
}

const TrashLayerWithRedux = connect(mapStateToProps)(TrashLayer);

export {TrashLayerWithRedux as TrashLayer};




// WEBPACK FOOTER //
// ./src/components/EventPage/images/TrashLayer.jsx